
<!-- Sidebar -->
<p-drawer [(visible)]="visible" [showCloseIcon]="false" position="right" [blockScroll]="true" (onHide)="HideSidebar()" [dismissible]="false"
  styleClass="w-full payment-sidebar p-0 no-header" aria-label="freeze-sidebar" data-testid="freeze-sidebar">
  <ng-template #headless>

  <!-- Header -->
  <div class="border-bottom-1 border-300 flex">
    <!-- Close Icon -->
    <div class="w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center "
      (click)="HideSidebar()" aria-label="close-sidebar-button" data-testid="close-sidebar-button">
      <i class="fa fa-times text-xl text-600"></i>
    </div>
    <!-- Close Icon -->

    <h4 class="text-sm m-2 p-1" data-testid="sidebar-header">
      {{'FREEZE.FREEZE_SIDEBAR.HEADER_FREEZE' | translate}}
    </h4>
  </div>
  <!-- Header -->

  <div class="p-sidebar-content__wrapper surface-100">

    <!-- Name -->
    <div class="flex px-3 py-2 align-items-center justify-content-between border-bottom-1 border-300" data-testid="client-info-section">
      <div class="flex align-items-center">
        <ng-container *ngIf="client.clt_image">
          <p-avatar image="{{client.clt_image}}" size="small" shape="circle" [attr.data-testid]="'client-avatar-' + client.clt_id"></p-avatar>
        </ng-container>
        <ng-container *ngIf="!client.clt_image">
          <p-avatar *ngIf="!client.clt_image" [label]="client2LetterName(client.clt_full_name) | titlecase | shortName"
            size="small" shape="circle" [attr.data-testid]="'client-avatar-' + client.clt_id">
          </p-avatar>
        </ng-container>
        <h3 class="mb-0 ml-2 md:-mt-1">
          <a href="javascript:void(0)"
            class="text-primary text-base mr-2 font-bold border-bottom-1 border-white hover:border-primary"
            [attr.data-testid]="'client-name-' + client.clt_id">
            {{client.clt_full_name}}
          </a>
          <span class="text-600 font-normal text-sm" [attr.data-testid]="'client-id-' + client.clt_id">
            {{'FREEZE.FREEZE_SIDEBAR.CLIENTID' | translate}} - {{client.clt_id}}
          </span>
        </h3>
      </div>
      <div [innerHTML]="clientStatus(client)" [attr.data-testid]="'client-status-' + client.clt_id"> </div>
    </div>
    <!-- Name -->

    <!-- Info Card -->
    <div class="shadow-2 border-round p-3 m-3 h-auto" data-testid="subscription-info-card">
      <div class="flex border-bottom-1 border-300 pb-3">
        <div
          class="bg-blue-50 border-1 border-primary border-round text-primary text-center uppercase px-2 py-1 inline-block text-xs mr-2"
          [innerHTML]="'POS.PLANTYPE.' + subscription.subscription_category.toString().toUpperCase() | translate"
          [attr.data-testid]="'subscription-category-' + subscription.id">
        </div>
        <h3 class="text-base font-bold ml-2 mb-0" [attr.data-testid]="'subscription-name-' + subscription.id">
          {{subscription.name_primary_language}}
        </h3>
      </div>
      <ul class="list-none grid pt-3 pb-2 px-0 m-0" *ngIf="IsRecurringSubscription" data-testid="freeze-attempts-list">
        <li class="col-12 md:col-6 py-1">
          <label class="block text-xs text-600 mb-1 font-medium uppercase" data-testid="freeze-attempts-label">
            {{'FREEZE.FREEZE_SIDEBAR.LABEL_FREEZEATTEMPTS' | translate}}
          </label>
          <strong [attr.data-testid]="'freeze-attempts-count-' + subscription.id">
            {{subscription.freeze_allowed_number_of_attempts_in_year}}
            {{'FREEZE.FREEZE_SIDEBAR.STRONG_EACHYEAR' | translate}}
          </strong>
          <ng-container *ngFor="let rf of CycleRemainingInYear">
            <div class="text-xs" [attr.data-testid]="'freeze-remaining-' + subscription.id + '-' + rf.year">
              <strong>
                {{ subscription.freeze_allowed_number_of_attempts_in_year < rf.count ? 0 :subscription.freeze_allowed_number_of_attempts_in_year - rf.count }} </strong> /
              {{subscription.freeze_allowed_number_of_attempts_in_year}} Remaining in {{rf.year}}
            </div>
          </ng-container>
        </li>
      </ul>
      <form [formGroup]="fg" (submit)="createFreeze()" data-testid="freeze-form">
        <div
          [ngClass]="IsRecurringSubscription ? 'border-top-1 border-300 py-3' : 'border-top-1 border-300 py-3 flex flex-wrap justify-content-between'">
          <ng-container *ngIf="!IsRecurringSubscription">
            <div class="w-6 pr-3">
              <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="start-date-label">
                {{'FREEZE.FREEZE_SIDEBAR.LABEL_STARTDATE' | translate}}
              </label>
              <p-datepicker [showIcon]="true" styleClass="w-full right-0-rtl"
                placeholder="{{'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTDATE' | translate}}" formControlName="startdate"
                inputStyleClass="text-sm" inputId="startDate" [readonlyInput]="true"
                aria-label="start-date-calendar" data-testid="start-date-calendar">
              </p-datepicker>
              <app-error-msg *ngIf="StartDateControl?.touched && StartDateControl?.invalid"
                [errors]="StartDateControl?.errors" [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.STARTDATE' | translate"
                data-testid="start-date-error">
              </app-error-msg>
            </div>
            <div class="w-6 pl-3">
              <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="end-date-label">
                {{'FREEZE.FREEZE_SIDEBAR.LABEL_ENDDATE' | translate}}
              </label>
              <p-datepicker [showIcon]="true" styleClass="w-full left-auto right-0 freeze-from-date"
                placeholder="{{'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTDATE' | translate}}" formControlName="enddate"
                inputStyleClass="text-sm" inputId="endDate" [readonlyInput]="true"
                aria-label="end-date-calendar" data-testid="end-date-calendar">
              </p-datepicker>
              <app-error-msg *ngIf="EndDateControl?.touched && EndDateControl?.invalid"
                [errors]="EndDateControl?.errors" [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.ENDDATE' | translate"
                data-testid="end-date-error">
              </app-error-msg>
            </div>

            <div class="w-12 -mb-3">
              <p-message severity="info" styleClass="relative" aria-label="freeze-days-message" data-testid="freeze-days-message">
                {{ 'FREEZE.FREEZE_DAYS' | translate : {count: calculateDays()} }}
              </p-message>
            </div>
          </ng-container>
          <ng-container *ngIf="IsRecurringSubscription">
            <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="freeze-cycle-label">
              {{'FREEZE.FREEZE_SIDEBAR.FREEZE_BILLING_CYCLE' | translate}}
            </label>
            <p-multiSelect [options]="filteredFreezeTimeline$.value"
              formControlName="selectedfreezeattempt" optionLabel="formated_date" display="chip"
              optionDisabled="is_frozen" styleClass="w-full text-sm" [selectionLimit]="selectionLimit"
              placeholder="{{'FREEZE.FREEZE_SIDEBAR.PLACEHOLDER_SELECTCYCLE' | translate}}"
              aria-label="freeze-cycle-multiselect" data-testid="freeze-cycle-multiselect">
              <ng-template pTemplate="selectedItem">
                <div class="text-sm" *ngIf="SelectedFreezeAttempt.value"
                  [innerHTML]="SelectedFreezeAttempt.value.formated_start_date">
                </div>
              </ng-template>
              <ng-template let-freezeAttempt pTemplate="item">
                <div class="text-sm" [innerHTML]="freezeAttempt.formated_start_date">
                </div>
              </ng-template>
            </p-multiSelect>
            <app-error-msg *ngIf="SelectedFreezeAttempt?.touched && SelectedFreezeAttempt?.invalid"
              [errors]="SelectedFreezeAttempt?.errors" [fieldLabel]="'FREEZE.FREEZE_SIDEBAR.ENDDATE' | translate"
              data-testid="freeze-cycle-error">
            </app-error-msg>
          </ng-container>
        </div>
        <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="comments-label">
          {{'FREEZE.FREEZE_SIDEBAR.COMMENTS' | translate}}
        </label>
        <textarea pInputTextarea class="w-full h-4rem" formControlName="comments"
          [placeholder]="'FREEZE.FREEZE_SIDEBAR.ADD_COMMENTS' | translate"
          aria-label="comments-textarea" data-testid="comments-textarea">
        </textarea>

        <div class="text-right mt-3">
          <button type="submit" pButton pRipple label="{{'FREEZE.FREEZE_SIDEBAR.BUTTON_APPLY' | translate}}"
            class="text-sm px-4" [loading]="btnLoading | async"
            aria-label="apply-freeze-button" data-testid="apply-freeze-button">
          </button>
        </div>
      </form>
    </div>
    <!-- Info Card -->

    <div class="px-3">
      <h6 class="mb-2 text-base font-normal" data-testid="freeze-history-header">
        {{'FREEZE.FREEZE_SIDEBAR.HEADER_FREEZEHISTORY' | translate}}
      </h6>

      <!-- Table -->
      <freeze-list [freeze]="freeze$" [issidebarview]="true" (isupdated)="IsUpdated($event)"
        aria-label="freeze-history-list" data-testid="freeze-history-list">
      </freeze-list>
      <!-- Table -->
    </div>
    </div>
  </ng-template>

</p-drawer>

<app-errors *ngIf="showErrorPopup | async as show_Popup" [visible]="show_Popup" [errorData]="errorMessages"
  [error]="error" (hideErrorPopup)="HideErrorPopup($event)"
  aria-label="error-dialog" data-testid="error-dialog">
</app-errors>
<!-- Sidebar -->
